// Skeleton Components
const SkeletonInput = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "40px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const SkeletonSelect = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "40px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const SkeletonTextarea = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "100px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const SkeletonDatePicker = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "40px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const AddMaintenanceSkeleton = () => {
  return (
    <div className="form-skeleton">
      {/* Form Inputs Skeleton */}
      <div className="row mb-4">
        {/* Vehicle Select */}
        <div className="col-12 col-md-4 mb-3">
          <SkeletonSelect labelWidth="100px" />
        </div>

        {/* Maintenance Type */}
        <div className="col-12 col-md-4 mb-3">
          <SkeletonSelect labelWidth="140px" />
        </div>

        {/* KM/Miles */}
        <div className="col-12 col-md-4 mb-3">
          <SkeletonInput labelWidth="100px" />
        </div>

        {/* Maintenance Date */}
        <div className="col-12 col-md-4 mb-3">
          <SkeletonDatePicker labelWidth="140px" />
        </div>

        {/* Expected Date */}
        <div className="col-12 col-md-4 mb-3">
          <SkeletonDatePicker labelWidth="140px" />
        </div>

        {/* Cost */}
        <div className="col-12 col-md-4 mb-3">
          <SkeletonInput labelWidth="80px" />
        </div>

        {/* Description */}
        <div className="col-12 mb-4">
          <SkeletonTextarea labelWidth="120px" />
        </div>
      </div>

      {/* Button Skeleton */}
      <div className="pt-4 mt-3 border-top text-end">
        <div
          className="skeleton-button d-inline-block me-3"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
        <div
          className="skeleton-button d-inline-block"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default AddMaintenanceSkeleton;
